var timeoutFlag = -1;
// 提示语，用在表单错误提示，提交错误&成功提示上
export function alertMessage(mes) {
    if (timeoutFlag >= 0) {
        clearTimeout(timeoutFlag);
    }
    var container = document.querySelector('#alertMes');
    if (!container) {
        container = document.createElement('div');
        container.id = 'alertMes';
        document.body.appendChild(container);
    }
    container.innerHTML = mes;
    container.style.display = 'block';
    timeoutFlag = setTimeout(function () {
        container.style.display = 'none';
    }, 3000);
    return container;
}

